import { Styles } from './styles';

export const defaultStyles: Styles = {
  control: {
    root: 'control',
    wrapper: 'wrapper',
    label: 'label',
    description: 'description',
    input: 'input',
    error: 'error',
    textarea: 'text-area',
    select: 'select',
    option: 'option',
  },
  verticalLayout: {
    root: 'vertical-layout',
    item: 'vertical-layout-item',
  },
  horizontalLayout: {
    root: 'horizontal-layout',
    item: 'horizontal-layout-item',
  },
  group: {
    root: 'group',
    label: 'group-label',
    item: 'group-item',
  },
  arrayList: {
    root: 'array-list',
    legend: 'array-list-legend',
    addButton: 'array-list-add',
    label: 'array-list-label',
    itemWrapper: 'array-list-item-wrapper',
    noData: 'array-list-no-data',
    item: 'array-list-item',
    itemToolbar: 'array-list-item-toolbar',
    itemLabel: 'array-list-item-label',
    itemContent: 'array-list-item-content',
    itemExpanded: 'expanded',
    itemMoveUp: 'array-list-item-move-up',
    itemMoveDown: 'array-list-item-move-down',
    itemDelete: 'array-list-item-delete',
  },
  label: {
    root: 'label-element',
  },
};
